import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchExperts } from "@/lib/api";
import { DisclaimerBanner } from "@/components/Disclaimer";
import InitialsAvatar from "@/components/InitialsAvatar";

export default function Experts() {
  const [experts, setExperts] = useState([]);
  useEffect(() => {
    fetchExperts().then(setExperts).catch(() => {});
  }, []);

  return (
    <div data-testid="experts-page">
      <div className="mb-1 font-mono text-[10px] uppercase tracking-[0.24em] text-[#64748b]">
        Tracked Voices
      </div>
      <h1 className="mb-4 text-2xl font-bold tracking-tight md:text-3xl">Experts</h1>
      <DisclaimerBanner />
      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {experts.map((e) => (
          <Link
            key={e.id}
            to={`/expert/${e.id}`}
            data-testid={`expert-card-${e.id}`}
            className="group flex items-start gap-3 border border-[#1e293b] bg-[#111827] p-4 transition-colors hover:border-[#3b82f6]/40"
          >
            <InitialsAvatar name={e.name} expertId={e.id} size="lg" />
            <div className="min-w-0">
              <div className="text-sm font-semibold text-[#f8fafc] group-hover:text-[#60a5fa]">
                {e.name}
              </div>
              <div className="font-mono text-[10px] uppercase tracking-wider text-[#64748b]">
                {e.title}
              </div>
              <div className="mt-1 line-clamp-2 text-xs text-[#94a3b8]">
                {e.focus}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
